import * as React from 'react';
import { useProductBlockSlots } from '../../../../slots/context.js';

const ProductBlockHeaderRight = ({ sku , productLocation , tabIndex  })=>{
    const { Slots  } = useProductBlockSlots();
    if (!Slots.WishlistButton) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-header-right"
    }, /*#__PURE__*/ React.createElement(Slots.WishlistButton, {
        sku: sku,
        productLocation: productLocation,
        tabIndex: tabIndex
    }));
};

export { ProductBlockHeaderRight };
//# sourceMappingURL=ProductBlockHeaderRight.js.map
